// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import axios from 'axios'
import 'element-ui/lib/theme-chalk/index.css'
import '../static/css/share.css' /* 引入公共样式 */
import global from './global'// 引用
import { configDatas } from './configs'

import Router from 'vue-router' // 引用配置信息
// 配置信息
Vue.prototype.configDatas = {
  baseTitle: '安全数字',
  kf_qrCode: '/static/img/code.jpg',
  kf_weixin: 'yr29809',
  appId: '', // 测试地址
  // appId: '', // 测试地址
  bgImg: '/static/img/bg3.png' // 首页背景图
}
// Vue.prototype.configDatas = configDatas

Vue.prototype.global = global
Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.prototype.firstEnter = true
axios.defaults.baseURL = process.env.NODE_ENV === 'production' ? '' : 'http://alipay-test.frp.weizhi.so'
axios.defaults.baseURL = process.env.NODE_ENV === 'production' ? '' : 'http://fkdemo1.frp.89ie.com'
axios.defaults.baseURL = process.env.NODE_ENV === 'production' ? '' : 'http://xdsfk.frp.89ie.com'
axios.defaults.baseURL = process.env.NODE_ENV === 'production' ? '' : 'http://fk-xds.frp.89ie.com'

// 手机或电脑
Vue.prototype.flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
Vue.prototype.axios = axios
if (Vue.prototype.flag) {
  // document.body.style.position = "absolute";
  // document.body.style.width = "1250px";
}
Vue.prototype.setHeadBg = function () {
  return 'background:#f5f5f5'
}
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
// 调试
// import VConsole from 'vconsole';
// let vconsole = new VConsole();
// export default vconsole;

// 调试结束

let loading
function startLoading() {
  loading = Vue.prototype.$loading({
    text: '正在加载',
    background: 'rgba(0, 0, 0, 0.1)'
  })
}
function endLoading() {
  loading.close()
}
function errors() {
  Vue.prototype.$message({
    message: '服务器开小差了',
    type: 'warning'
  })
}

Vue.prototype.copy = function (data) {
  let url = data
  let oInput = document.createElement('input')
  oInput.value = url
  document.body.appendChild(oInput)
  oInput.select() // 选择对象;
  document.execCommand('Copy') // 执行浏览器复制命令
  this.$message({
    message: '复制成功',
    type: 'success'
  })
  oInput.remove()
}

Vue.prototype.checkPhone = function (e) {
  let myPhone = wx.getStorageSync('myPhone')
  let status = !hh.isPhone(myPhone)
  if (status) {

  }
}
if (Vue.prototype.flag) {

}
Vue.prototype.openUrl = function (url, datas = {}) {
  this.$router.push({ path: url, query: datas })
}
Vue.prototype.backs = function () {
  this.$router.go(-1)
}
Vue.prototype.shg = document.body.clientHeight - 120
Vue.prototype.fixed = true
Vue.prototype.goBack = function (item = -1) {
  this.$router.go(item)
}

Vue.prototype.apiGet = function (url, data, cb, status = true) {
  if (status) {
    startLoading()
  }
  return new Promise((resolve, reject) => {
    axios.get(url, { params: data }).then((response) => {
      if (status) {
        endLoading
      }
      cb(response.data)
      resolve(response.data)
    }, (response) => {
      reject(response)
    })
  })
}
Vue.prototype.apiPost = function (url, data, cb) {
  startLoading()
  return new Promise((resolve, reject) => {
    axios.post(url, data).then((response) => {
      endLoading
      resolve(response.data)
      return cb(response.data)
    }).catch((response) => {
      reject(response)
      return cb(response.data)
    })
  })
}

// 拦截器
axios.interceptors.request.use(function (config) {
  config.headers = {
    'wx-token': sessionStorage.getItem('token') || ''
    // 'wx-token': sessionStorage.getItem('token')||'029b8cc932604c32b1f95f8b41eda9e4'
  }
  return config
}, function (error) {
  console.log(error)
  return Promise.reject(error)
})

// 返回状态判断(添加响应拦截器)，axios时基于promise的异步请求
axios.interceptors.response.use(
  res => {
    endLoading()
    // alert(JSON.stringify(res.data.msg))
    if (res.data.code == 403||res.data.msg=='wx_token 没有传递') {
      let link = window.location.protocol + '//' + document.domain
      let appid = Vue.prototype.configDatas['appId']
      let redirect_uri = link + '/home'
      let url = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + appid + '&redirect_uri=' + redirect_uri + '&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect'
      window.location.href = url
    }
    return res
  },
  error => {
    console.log('error', error)
    endLoading()
    if (res.data.code == 101 || res.data.code == 102) {
      return
    }
    errors()
  }
)
// 前路由守卫
router.beforeEach((to, from, next) => {
  if (!Vue.prototype.configDatas.appId) {
    Vue.prototype.apiGet('/h5/api/common/getWxConfig', {}, res => {
      if (res.state) {
        Vue.prototype.configDatas.appId = res.data.appId;

        if (to.query.bid) {
          localStorage.setItem('bid', to.query.bid)
        }
        if (to.path == '/taobao/exchange') {
          localStorage.setItem('enterUrl', '/taobao/exchange')
        } else {

        }
        if (to.path == '/join/group') {
          localStorage.setItem('enterUrl', '/join/group')
          if (to.query.groupCode) {
            localStorage.setItem('groupCode', to.query.groupCode)
          }
        }
        if (to.meta.requireAuth) {
          let token = sessionStorage.getItem('token') || ''
          if (token) {
            next()
          } else {
            if (to.query.code) {
              next()
            } else {
              let appid = Vue.prototype.configDatas.appId
              let link = window.location.protocol + '//' + document.domain
              let redirect_uri = link + '/home'
              console.log('redirect_uri=======' + redirect_uri)
              if (to.path == '/taobao/exchange') {
                redirect_uri = link + '/taobao/exchange'
              }
              if (to.path == '/join/group') {
                redirect_uri = link + '/join/group'
              }
              let url = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' +
                appid +
                '&redirect_uri=' +
                redirect_uri +
                '&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect'
              window.location.href = url
            }

          }
        } else {
          next()
        }
      } else {
      }
    })
  } else {

    if (to.query.bid) {
      localStorage.setItem('bid', to.query.bid)
    }
    if (to.path == '/taobao/exchange') {
      localStorage.setItem('enterUrl', '/taobao/exchange')
    } else {

    }
    if (to.path == '/join/group') {
      localStorage.setItem('enterUrl', '/join/group')
      if (to.query.groupCode) {
        localStorage.setItem('groupCode', to.query.groupCode)
      }
    }
    if (to.meta.requireAuth) {
      let token = sessionStorage.getItem('token') || ''
      if (token) {
        next()
      } else {
        if (to.query.code) {
          next()
        } else {
          let appid = Vue.prototype.configDatas['appId']
          let link = window.location.protocol + '//' + document.domain
          let redirect_uri = link + '/home'
          console.log('redirect_uri=======' + redirect_uri)
          if (to.path == '/taobao/exchange') {
            redirect_uri = link + '/taobao/exchange'
          }
          if (to.path == '/join/group') {
            redirect_uri = link + '/join/group'
          }
          let url = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' +
            appid +
            '&redirect_uri=' +
            redirect_uri +
            '&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect'
          window.location.href = url
        }

        next()
      }
    } else {
      next()
    }
  }

})
// 后路由守卫
router.afterEach((to, from) => {
  // let path = from.path.split('/');
  // console.log(path)
  // localStorage.setItem("path", path[1]||'home');
  // console.log('-------------', configDatas.RESURL, configDatas,'----------')

})

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js